import { cn } from '@/shared/lib/cn';

interface AppLogoProps {
    title?: string;
    showTitle?: boolean;
    className?: string;
    badgeClassName?: string;
    imageClassName?: string;
    titleClassName?: string;
}

export function AppLogo({ title = 'Milpilots', showTitle = true, className, badgeClassName, imageClassName, titleClassName }: AppLogoProps) {
    return (
        <div className={cn('flex items-center gap-2', className)}>
            <div className={cn('grid size-8 place-items-center rounded-lg', badgeClassName)}>
                <img src="/assets/logo.svg" alt={title} className={cn('size-8', imageClassName)} />
            </div>
            {showTitle && <span className={cn('truncate text-base font-semibold', titleClassName)}>{title}</span>}
        </div>
    );
}
